<template>
  <section class="whiteBox">
    <div class="content">
      <div class="row">
        <p class="accentuate">{{$t('campaigns.lastUsesSection')}}</p>
      </div>
      <div class="row">
        <table>
          <thead>
            <tr>
              <th class="accentuate">{{$t('coupons.couponCode')}}</th>
              <th class="accentuate">{{$t('dateManagement.date')}}</th>
              <th class="accentuate">{{$t('campaigns.discount')}} </th>
              <th class="accentuate">{{$t('campaignStatus.status')}}</th>
              <th class="accentuate">{{$t('couponHistory.idTransaction')}}</th>
              <th class="accentuate">{{$t('couponHistory.idClient')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="couponuse in couponHistory"
              :key="couponuse.title"
            >
              <td>{{couponuse['coupon-value']}}</td>
              <td>{{moment(couponuse['transaction-date']).format(`DD/MM/YYYY ${$t('dateManagement.at')} HH[${$t('dateManagement.hourSeparator')}]mm`)}}</td>
              <td> <span
                  v-if="couponuse['applied-discount']!=0"
                  class="chipValue lightorange"
                >{{'-'+(couponuse['applied-discount']/100).toFixed(2) + convertCurrencyToSymbol(couponuse['discount-currency'])}}</span>
                <span
                  v-else
                  class="chipValue void"
                >{{$t('discountValue.noDiscount')}} </span>
                <span v-if="couponuse['product-name'] && couponuse['sales-channel-name']"> {{couponuse['product-name']}} | {{couponuse['sales-channel-name']}}</span></td>
              <td>
                <p
                  v-if="couponuse['transaction-status']==0"
                  class="chip grey"
                >{{$t('couponStatus.notUsed')}}</p>
                <p
                  v-if="couponuse['transaction-status']==1"
                  class="chip greyBold"
                >{{$t('couponStatus.retrieved')}}</p>
                <p
                  v-if="couponuse['transaction-status']==2"
                  class="chip lightorange"
                >{{$t('couponStatus.verified')}}</p>
                <p
                  v-if="couponuse['transaction-status']==3"
                  class="chip orange"
                >{{$t('couponStatus.autorized')}}</p>
                <p
                  v-if="couponuse['transaction-status']==4"
                  class="chip green"
                >{{$t('couponStatus.confirmed')}}</p>
              </td>
              <td>{{couponuse['merchant-order-id']}}</td>
              <td>{{couponuse['merchant-reference']}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="spacer-10"></div>
      <div class="spacer-10"></div>
      <div class="spacer-10"></div>
      <div
        v-if="couponHistory.length>0"
        class="row"
      >
        <button @click="$router.push({name: 'detailCouponHistory', params: { id: parCampaignId}})">{{$t('button.showAll')}}</button>
      </div>
    </div>
  </section>
</template>


<script>
import CouponHistory from "@/services/CouponHistory";
import generalMethods from "@/mixins/generalMethods";
export default {
  props: ["parCampaignId"],
  mixins: [generalMethods],
  mounted() {
    this.getCouponHistory(this.parCampaignId);
  },
  data() {
    return {
      couponHistory: []
    };
  },
  methods: {
    getCouponHistory(campaignId) {
      CouponHistory.getByCampaignId(campaignId).then(res => {
        if (res.status == 200) {
          res.data.sort(function(a, b) {
            //DESC order
            return a["transaction-date"] < b["transaction-date"]
              ? 1
              : a["transaction-date"] > b["transaction-date"]
              ? -1
              : 0;
          });
          //Limit to 10 last uses
          this.couponHistory = res.data.splice(0, 10);
        }
      });
    }
  }
};
</script>
<style scoped>
</style>

